import { useState, useEffect } from "react";
import CaptchaPage from "../../captcha/captchaPage";
import "../login.css";
import InputField from "../../../library/components/InputField";
import PasswordField from "../../../library/components/Password";
import Button from "../../../library/components/Button";
import { Link, useNavigate } from "react-router-dom";
import { Validators } from "../../../library/utilities/Validator";
import { otpserviceApi } from "../../../services/User_management/otpService";
import { useDispatch } from "react-redux";
import { createAlert } from "../../../features/alert/alerts";
import { ALERT_TYPE_SUCCESS } from "../../../constants/constants";
import { ALERT_TYPE_ERROR } from "../../../constants/constants";
import SelectField from '../../../library/components/Select'
import { useGetCaptchaServiceQuery } from "../../../services/captchaService";
import ReactCountdownClock from "react-countdown-clock";



function ForgotPassword({ forgetPasswordObj, setForgetPasswordObj }) {
  const [errorValue, setErrorValue] = useState({});
  const [captchaId, setCaptchaId] = useState("");
  const [captchaImage, setCaptchaImage] = useState();
  const [captchaArg, setCaptchaArg] = useState(true);
  const [errorData, setErrorData] = useState("");
  const [buttoneDis, setbuttoneDis] = useState(true)
  const [isDisable, setDisable] = useState(true);
  const [enableOTPField, setEnableOTPField] = useState(true);
  const [disableOTPButton, setDisableOTPButton] = useState(true);
  const [isOTPVerified, setOtpVerified] = useState(false);
  const [Error, setError] = useState({});
  const [GETOTP ,datap] = otpserviceApi.useSendotpMutation();
  const [ResendOTP ,dataU] = otpserviceApi.useSendotpMutation();
  const [VERIFYOTP] = otpserviceApi.useVerifyotpMutation();
  const [showOtpButton, setShowOtpButton] = useState(false);
  const [showOtpTimer, setShowOtpTimer] = useState(false);
    const [secondStep,setSecondStep]=useState(false)
  const {
    data: captchaData,
  } = useGetCaptchaServiceQuery([captchaArg], {
    refetchOnMountOrArgChange: true,
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getErrorValue = (key, value) => {
    let error = { ...Error }
    if (value && value.message) {
      setError({ ...Error, [key]: value.message })
    } else {
      delete error[key]
      setError(error)
    }
  }

console.log(forgetPasswordObj)
  useEffect(() => {
    if (captchaData) setCaptchaImage(captchaData);
  }, [captchaData]);

    const [changeEciPassword] = otpserviceApi.useEciForgotPasswordMutation();

    const onSuccess = (msg) => {
      dispatch(
        createAlert({
          message: msg,
          type: ALERT_TYPE_SUCCESS,
          heading: "Success",
        })
      );
    };
  
    const onReject = (msg) => {
      dispatch(
        createAlert({
          message: msg,
          type: ALERT_TYPE_ERROR,
          heading: "Reject",
        })
      );
    };

    const getOTP = () =>{
      setDisableOTPButton(true);
         const data = {
           userId: forgetPasswordObj.mobile_epic_number,
           captcha: captchaId,
           captchaId: captchaData?.id,
           isTest: "true"
       }
       if (data.userId) {
         GETOTP(data)
           .unwrap()
           .then((res) => {
             setDisableOTPButton(false)
             setShowOtpButton(false);
             setShowOtpTimer(true)
             setForgetPasswordObj((prev) =>({
               ...prev,
               ["otp"] : "",
               ["confirmpassword"] : "",
               ["newpassword"] : ""
             }));
             onSuccess(res.message)
             setSecondStep(true)
           })
           .catch((error) => {
             onReject(error.message)
             setDisableOTPButton(true)
             setForgetPasswordObj((prev) =>({
              ...prev,
              ["otp"] : "",
              ["confirmpassword"] : "",
              ["newpassword"] : ""
            }));
           });
       }
     }

     const resendOTP = () =>{
      setDisableOTPButton(false);
         const data = {
           userId: forgetPasswordObj.mobile_epic_number,
       }
       if (data.userId) {
        ResendOTP(data)
           .unwrap()
           .then((res) => {
             setDisableOTPButton(false)
             setShowOtpButton(false);
             setShowOtpTimer(true)
             setForgetPasswordObj((prev) =>({
               ...prev,
               ["otp"] : "",
               ["confirmpassword"] : "",
               ["newpassword"] : ""
             }));
             onSuccess(res.message)
           })
           .catch((error) => {
             onReject(error.message)
             setDisableOTPButton(false)
             setForgetPasswordObj((prev) =>({
              ...prev,
              ["otp"] : "",
              ["confirmpassword"] : "",
              ["newpassword"] : ""
            }));
           });
       }
     }


     useEffect(()=>{
      setForgetPasswordObj((prevState) => ({
        ...prevState,
        ["otp"]: "",
        ["newpassword"]:"",
        ["confirmpassword"]:""
        
      }));
      setDisableOTPButton(true)
      setOtpVerified(false)
    },[forgetPasswordObj.mobile_epic_number])
   

     const verifyOtp = () =>{
       setDisableOTPButton(true);
          const data = {
           userId: forgetPasswordObj.mobile_epic_number,
           otp: forgetPasswordObj.otp
        }
   
        if (data.userId) {
          VERIFYOTP(data)
            .unwrap()
            .then((res) => {
              setDisableOTPButton(false)
              setOtpVerified(true);
              setShowOtpButton(false);
              setShowOtpTimer(false)
              onSuccess(res.message)
            })
            .catch((error) => {
              onReject(error.message)
              setDisableOTPButton(false)
              setOtpVerified(false);
            });
        }
      }

    const changePassword = () => {
        const data = {
          passwordRequest: forgetPasswordObj.newpassword,
          userId: forgetPasswordObj.mobile_epic_number,
          userType: forgetPasswordObj.userType,
          otp: forgetPasswordObj?.otp
        }
        changeEciPassword(data)
          .unwrap()
          .then((res) => {
            onSuccess(res.message)
            navigate("/login");
          })
          .catch((error) => {
            onReject(error.data?.message)
          });
    };

    useEffect(()=>{
      if(forgetPasswordObj.userType!=="" &&forgetPasswordObj.newpassword?.length !== 0 && forgetPasswordObj.otp && !Error.otp &&
        forgetPasswordObj.confirmpassword !==0 &&
        forgetPasswordObj.newpassword === forgetPasswordObj.confirmpassword &&
        !Error.newpassword)
      {
        setDisable(false);
      }
      else{
        setDisable(true);
      }
    })
  const handleChange = (key, event) => {
    setForgetPasswordObj({ ...forgetPasswordObj, [key]: event});
  };

  useEffect(()=>{
    setEnableOTPField(true);
    setErrorValue({})
  },[buttoneDis])

const myCallback = (e) => {
  setShowOtpTimer(false);
  setShowOtpButton(true);
};

console.log(forgetPasswordObj.otp.length==6 && !Error.otp)
  return (
  <div className="mr-2">
      <div className="row p-2">
        <div className="col-sm-12 heading_login">
          {secondStep &&<p className="heading_login_subtitle" onClick={()=>{setSecondStep(false)}}><i className="fa fa-backward"></i> back</p>}
          <h4>Forgot Password</h4>
          {/* <p>
            Remember Password? <Link to="/login">Login</Link>
          </p> */}
        </div>
      </div>
      {!secondStep && <div >
    

      <div className="row p-2">
        
        <InputField
          label="User ID."
          disabled={datap.isSuccess}
          onPaste={true}
          onDrop={true}
          onCopy={true}
          onCut={true}
          autoComplete={"off"}
          maxLength="100"
          name="mobile_epic_number"
          required={true}
          iconclass="fas fa-envelope"
          placeholder="Enter User ID"
          inputClass="col-md-12 forminputLogin"
          labelClass="col-md-12 d-none"
          value={forgetPasswordObj.mobile_epic_number}
          onChange={(val) => handleChange("mobile_epic_number", val)}
          getError={(value) => getErrorValue("mobile_epic_number", value)}
          validators={[
            {
              check: Validators.required,
              message: "This field is required",
            },
            {
              check: Validators.nospecial,
              message: "Please enter valid userId.",
            },
          ]}
          Error={Error}
        />
      </div>
      <div className="row p-2">
        <div className="col-md-12 captchatext">
        <CaptchaPage
            error={errorData}
            buttonDisabled={Object.keys(Error).length != 0 || datap.isSuccess}
            captchaData={captchaData}
            setCaptchaArg={setCaptchaArg}
            setCaptchaId={setCaptchaId}
            setErrorMsg={setErrorData}
            captchaArg={captchaArg}
            captchaId={captchaId}
            onPaste={true}
            onDrop={true}
            onCopy={true}
            onCut={true}
            autoComplete={"off"}
            captchaText="Captcha"
               captchaLabel={"d-none"}
            style={"forminputCaptcha"}
          />
      </div>
      </div>
   <div className="row p-2 pl-4"> 
      <Button
        btnClass="btn-block save-btn btnpurple"
        value="Send OTP"
        disabled={  Object.keys(Error).length != 0 ||
          captchaId == "" ||
          forgetPasswordObj.mobile_epic_number == "" ||
          forgetPasswordObj.userType == "" || datap.isSuccess
        }
        onClick={() => {
          getOTP();
        }}
      />
      </div>
 </div>}
  {secondStep && <div>
      <div className="row p-2">
        <InputField
          iconclass="fas fa-mobile-alt"
                    inputClass="col-md-12 forminputLogin"
          labelClass="col-md-12 d-none"
          label="Enter otp"
          placeholder="Enter OTP"
          type="text"
          required={true}
          disabled={disableOTPButton}
          getError={(value) => getErrorValue("otp", value)}
          name="Otp"
          value={forgetPasswordObj.otp}
          onChange={(val) => handleChange("otp", val)}
          validators={[
            {
              check: Validators.required,
              message: "this field is required",
            },  
            {
              check: Validators.OTPRegEx,
              message: "Please enter valid OTP"
            }          
          ]}
        />
        
        {/* <div className="col-md-6">
          <Button btnClass="save-btn"
             value= { forgetPasswordObj.otp &&  isOTPVerified ? "OTP Verified" : "Verify OTP"} 
          disabled={disableOTPButton === false ? (forgetPasswordObj.otp && !Error.otp) ? false : true : true}
           onClick={(()=>{
             verifyOtp();
           })}/>
        </div> */}
      
       
      </div>
      {showOtpButton && (
           <Button
        btnClass="btn-block save-btn btnpurple"
        value="Resend OTP"
        onClick={() => {
          resendOTP();
        }}
      />
        )}
          {showOtpTimer && (
          <div
            className="row mt-2"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div className="mt-3">
              <h6>Resend OTP in :</h6>
            </div>
            <div className="ml-3">
              <ReactCountdownClock
                seconds={180}
                color="green"
                alpha={0.9}
                size={50}
                showMilliseconds={false}
                onComplete={myCallback}
              />
            </div>
          </div>
        )}
      <div className="row p-2">
        <PasswordField
          iconclass="fas fa-eye"
          inputClass="col-md-12 forminputLogin"
          labelClass="col-md-12 d-none"
          label="New Password"
          placeholder="New Password"
          required={true}
          name="newpassword"
          onDrop={true}
          onCopy={true}
          onCut={true}
          autoComplete={"off"}
          // disabled={(isOTPVerified === true && forgetPasswordObj.otp)? false: true}
          disabled={ (forgetPasswordObj.otp.length==6 && !Error.otp)?false:true}
          value={forgetPasswordObj.newpassword}
          onChange={(val) => handleChange("newpassword", val)}
          getError={(value) => getErrorValue("newpassword", value)}
          validators={[
            {
              check: Validators.passwordupper,
              message: "Atleast one uppercase required",
            },
            {
              check: Validators.passwordSpace,
              message: "Must not contain space",
            },
            {
              check: Validators.passworddigit,
              message: "Atleast one digit required",
            },
            {
              check: Validators.passwordspecial,
              message: "Atleast one valid special character(@ , _ - ! # .) required",
            },
            {
              check: Validators.passwordmin,
              message: "Atleast eight characters required",
            },
            {
              check: Validators.required,
              message: "This field is required",
            },
          ]}
          Error={Error}
          
        />
      </div>
     <div className="row pr-4 pl-2">
        <small>
          Password should contain the following,
          <ul>
            <li>At least Eight Characters</li>
            <li>At least One Capital Letter (A-Z)</li>
            <li>At least One Number (0-9)</li>
            <li>At least One Special Character</li>
            <li>Should not contain any space</li>
          </ul>
        </small>
      </div>

      <div className="row p-2">
        <PasswordField
          iconclass="fas fa-eye"
          inputClass="col-md-12 forminputLogin"
          labelClass="col-md-12 d-none"
          label="Confirm Password"
          name="confirmpassword"
          placeholder="Confirm Password"
          required={true}
          onDrop={true}
          onCopy={true}
          onCut={true}
          autoComplete={"off"}
          disabled={ (forgetPasswordObj.otp.length==6 && !Error.otp)?false:true}
          // disabled={disableOTPButton || forgetPasswordObj.otp || !Error.otp}
          value={forgetPasswordObj.confirmpassword}
          onChange={(val) => handleChange("confirmpassword", val)}
          getError={(value) => getErrorValue("confirmpassword", value)}
          validators={[
            {
              check: Validators.passwordupper,
              message: "Atleast one uppercase required",
            },
            {
              check: Validators.passwordSpace,
              message: "Must not contain space",
            },
            {
              check: Validators.passworddigit,
              message: "Atleast one digit required",
            },
            {
              check: Validators.passwordspecial,
              message: "Atleast one valid special character(@ , _ - ! # .) required",
            },
            {
              check: Validators.passwordmin,
              message: "Atleast eight characters required",
            },
            {
              check: Validators.required,
              message: "This field is required",
            },
          ]}
          Error={Error}
        />
      </div>
      <Button
        btnClass="btn-block submit btnpurple"
        disabled={isDisable}
        value= { "Change Password"}
        onClick={()=>{
          changePassword() 
        }}
      />

      <div className="signup">
        Know Password? <Link to="/login">Login</Link>
      </div>
      </div>}
    </div>
  );
}

export default ForgotPassword;
